import { useEffect } from 'react';
import { AppRoutes } from '@/routes';
import { useAuthStore } from '@/stores/authStore';

export function App() {
  const initialise = useAuthStore((s) => s.initialise);

  // On mount, attempt a silent token refresh (httpOnly cookie)
  useEffect(() => {
    initialise();
  }, [initialise]);

  return <AppRoutes />;
}
